import { render, staticRenderFns } from "./CustomFilter.vue?vue&type=template&id=fb1c24a8&"
import script from "./CustomFilter.vue?vue&type=script&lang=js&"
export * from "./CustomFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports